// extracted by mini-css-extract-plugin
export default {"sidebar":"LayoutStyle_sidebar__HB--n","css-7vc89i-MuiDrawer-docked":"LayoutStyle_css-7vc89i-MuiDrawer-docked__vLjnI","MuiDrawer-paper":"LayoutStyle_MuiDrawer-paper__0XzX8"};